var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendsSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.5 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #756ab6;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #756ab6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 23.75,
    cy: 27.03,
    rx: 14.75,
    ry: 11.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.06,20.3s-4.56-2.8-1.56-5.8,6,3,6,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.42,20.16s4.55-2.6,1.56-5.38c-2.99-2.78-5.98,2.78-5.98,2.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 7,
    x2: 16,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8,
    y1: 15,
    x2: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsSolid);
export default __webpack_public_path__ + "static/media/Friends-Solid.fd675e08af1c7ac9668bf93275eecbcd.svg";
export { ForwardRef as ReactComponent };